import * as React from "react";
import { Loader } from "sb-resp-ui";
export class SuperBannerLoader extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-superbanner__loader" },
            React.createElement(Loader, null)));
    }
}
//# sourceMappingURL=SuperBannerLoader.js.map